<template>
    <div class="p-1">
       <div-table :config="configList" :data="expeditions"  
       :idWharhouse="idWharhouse"
       :sous_idWharhouse="sous_idWharhouse" :sous_warehouses="sous_warehouses"
        :currentUser="currentUser" 
       :sellers="sellers" :CheckExpeditionRecived="CheckExpeditionRecived" 
       @CheckQteSentExist="CheckQteSentExist"
       :element="element" :ProcessingInfo="ProcessingInfo" :statusExpedition="statusExpedition"
       :transports="transports"
       @reset="reset"  @refresh="refresh" @showProducts="showProducts" @filtrer="filtrer"
       @search="search" :loading="loading"
       :paginate="paginate" @paginatation="paginatation"></div-table>
    </div>
</template>
<script>
import button from "../../components/~/button.vue";
import config from './config'
export default {
    props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object},
     sous_idWharhouse: { type: String},
     sous_warehouses: { type: Array},
   },
    data() {
        return {
            configList: config.list,
            loading:false,
            formData: {
                carrier: {},
            },
            expeditions: [],
            element: {},
            show_modal: false,
            limit: 100,
             filters:{},
            paginate: {
                total: 0,
                currentpage: 1,
                lastpage: 0,
                per_page: 0,
            },
            sellers: [],
            statusExpedition: ["expedited", "received","processed", "cancelled"],
            transports:  ["road","railway","air", "maritime"],
            country:this.$countries,
            CheckExpeditionRecived:false ,
            ProcessingInfo:{count:0,total:0}
        };
    },
    computed: {
        warhouseSelected(){
            return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
        },
    }, 
    watch: { 
        'warhouseSelected': async function(oldVal, newVal) {
            // await this.getwharhouseId();
            // await this.reset();
            // if (this.currentUser.type != "Seller") {  await this.getSellers();this.setDataSelect("seller", this.sellers, null);} 
        },
        'idWharhouse': async function(oldVal, newVal) {
          this.idWharhouse=oldVal;  
          await this.reset();
          if (this.currentUser.type != "Seller") {  await this.getSellers();this.setDataSelect("seller", this.sellers, null);} 
        },
        'sous_idWharhouse': async function(oldVal, newVal) {
          this.sous_idWharhouse=oldVal;  
          if(this.currentUser.type != "Admin") {this.limit=10;this.filters.limit=10}
          await this.reset();
        }
    },
    async mounted() {
        if(this.currentUser.type != "Admin") {this.limit=10;this.filters.limit=10}
        
         if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
         else {
            let filtersobjectToQueryString={limit:this.limit,warehouse:this.idWharhouse._id};
            if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filtersobjectToQueryString['details.warehouseParent']=this.sous_idWharhouse;
            this.$f.objectToQueryString(filtersobjectToQueryString)
        }

        if(this.filters.name) await this.search(this.filters.name);
        else await this.getExpeditions(this.filters);
        if (this.currentUser.type != "Seller") {
            await this.getSellers();
            this.setDataSelect("seller", this.sellers, null);
        }
        this.setDataSelect("status", this.statusExpedition, null);
        this.setDataSelect("transportMode", this.transports, null);
        this.setDataSelect("country", this.country, null);
          if (this.currentUser.type == "Seller") {
            let pos = this.configList.columns.map(function (e) {
                        return e.name;
                        }).indexOf('Seller');
            if(pos!=-1)  this.configList.columns.splice(pos, 1);           
         }
    },
    methods: {
        async getwharhouseId(){
           await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
       }, 
        setDataSelect(model, data, splice) {
            for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
                if (
                this.configList.filters.elements.champs[i].type === "select" &&
                this.configList.filters.elements.champs[i].key === model
                ) {
                if (!splice) {
                    this.configList.filters.elements.champs[i].values = data;
                } else {
                    this.configList.filters.elements.champs.splice(i, 1);
                }
                }
            }
        },
        async CheckQteSentExist(item){
            console.log('iteeeem',item.details)
            this.CheckExpeditionRecived=false;
            if(item.status=='received' ){
                for (let i in item.details) {
                    const filters = {
                    product: item.details[i].product._id,
                    expedition: item._id,
                    };
                const res = await this.$server.search("stockHistories", filters);
                
                    if(typeof res.content.results !== 'undefined') {
                        this.CheckExpeditionRecived=true;
                    }
                }
            }    
        }, 
        async getSellers() {
            if (this.currentUser.type != "Seller") {
                const filter = {
                    type: "Seller",
                    warehouses:this.idWharhouse._id,
                    limit:10,
                };
                if (this.currentUser.type != "Seller") {
                    const res = await this.$server.search("users", filter);
                    if (res.content.results) this.sellers = res.content.results;
                    else this.sellers = [];
                }
            }
        },
        async reset(data) {
            let lmitt=this.limit;
            if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
            if(this.filters['limit']) lmitt=this.filters['limit'];
            this.filters['page']=1;
            let filtersobjectToQueryString={limit:lmitt,warehouse:this.idWharhouse._id};
            if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filtersobjectToQueryString['details.warehouseParent']=this.sous_idWharhouse;
            this.$f.objectToQueryString(filtersobjectToQueryString)
            await this.getExpeditions( {limit:lmitt});
        },
        async filtrer(data) {
         if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
          delete  this.filters.page;
          delete  this.filters.name;

         if(!this.filters['limit']) this.filters['limit']=this.limit;
         if(data.status) this.filters.status=data.status;else delete this.filters.status;
         if(data.transportMode) this.filters.transportMode=data.transportMode;else delete this.filters.transportMode;
         if(data.country) this.filters.country=data.country.name;else delete this.filters.country;
         if(data.weight) this.filters.weight=data.weight;else delete this.filters.weight;
         if(data.seller) this.filters.seller=data.seller._id;else delete this.filters.seller;
         if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') this.filters['details.warehouseParent']=this.sous_idWharhouse;else delete this.filters['details.warehouseParent'];
         this.paginate.currentpage=1;
         this.$f.objectToQueryString(this.filters)
        await this.getExpeditions(this.filters);
        },
        async search(data) {
             this.paginate= {total: 0,currentpage: 1,lastpage: 1,per_page: 0,};
            let limitt=this.limit
            if(this.filters['limit']) limitt=this.filters['limit'];
            const search = {
              name:data.trim(), limit:parseInt(limitt)
            }
            search.warehouse=this.idWharhouse._id
            if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') search['details.warehouseParent']=this.sous_idWharhouse;
            this.$f.objectToQueryString(search)
            const res = await this.$server.find("expeditions", search);
              if (res.content.results) {
                this.expeditions = res.content.results;
                this.paginate.total = res.content.total;
                this.paginate.lastpage = res.content.last_page;
                this.paginate.per_page = res.content.per_page;
                this.paginate.currentpage = res.content.current_page;
                for (const element of  this.expeditions) {
                    element.arrivalDate=element.arrivalDate?this.$moment(element.arrivalDate).format('yyyy-MM-DDTHH:mm'):'';
                 }
            } else {
                this.expeditions = []; this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
            }
        },
        async getUser() {
            const res = await this.$me;
            this.currentUser = res.content;
        },
        async getExpeditions(filters) {
            this.loading=true;
            filters.warehouse = this.idWharhouse._id;
            if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filters['details.warehouseParent']=this.sous_idWharhouse;
            if(!filters.limit) filters.limit=this.limit;
            console.log('filter exp--------',filters)
            const res = await this.$server.search("expeditions", filters);
            this.loading=false;
            this.ProcessingInfo.count=0;this.ProcessingInfo.total=0;
            if (res && res.content.results) {
                this.expeditions = res.content.results;
                this.paginate.total = res.content.total;
                this.paginate.lastpage = res.content.last_page;
                this.paginate.per_page = res.content.per_page;
                this.paginate.currentpage = res.content.current_page;
                 for (const element of  this.expeditions) {
                    element.arrivalDate=element.arrivalDate?this.$moment(element.arrivalDate).format('yyyy-MM-DDTHH:mm'):'';
                    if(element.isProcessed && element.status==="received") {
                        console.log('ooooooooook ')
                        this.ProcessingInfo.total+=element.fees;
                        this.ProcessingInfo.count++;
                    }
                 }
            } else {
                this.expeditions = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
            }
        },
        async refresh() {
            if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
            this.$f.objectToQueryString(this.filters)
            if(this.filters.name) await this.search(this.filters.name);
            else await this.getExpeditions(this.filters);
            if(this.filters['page'] && this.filters['page']>1 && this.expeditions.length==0){
                this.filters['page']= --this.filters['page'];
                this.$f.objectToQueryString(this.filters)
                await this.getExpeditions(this.filters);
            }
        },
        showProducts(index) {
            if (this.element !== this.expeditions[index]) {
                this.element = this.expeditions[index];
                console.log("Je suis this.element", this.element);
            } else this.element = null;
        },
        async remove(id) {
            this.$confirm("You want to delete this expedition?").then(async (res) => {
                if (res) {
                    const resp = await this.$server.delete("expeditions", { id: id });
                    await this.refresh();
                    alert("expedition Deleted", "success");
                }
            });
        },
        async paginatation(direction){
            var page=0;
            if(direction == "next"){
                page=++this.paginate.currentpage;
            }else{
                page=--this.paginate.currentpage;
            }

            if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
            this.filters['page']=page;
            this.$f.objectToQueryString(this.filters);

           await this.getExpeditions(this.filters);
      },
    },
};
</script>